export const APP_DATABASE_EDGE_COLOR = '#FF8C74';
export const APP_SERVER_EDGE_COLOR = '#FF8C74';
export const AWS_ORANGE_COLOR = 'rgb(255, 153, 0)'; // FF9900
export const BLUE_COLOR = 'rgb(82, 127, 255)'; // 527FFF
export const GREEN_COLOR = 'rgb(22, 191, 159)'; // 16BF9F
export const ON_PREMISES_COLOR = 'rgb(32, 119, 180)'; // 2077B4
export const PURPLE_COLOR = 'rgb(161, 102, 255)'; // A166FF
export const SERVER_COMMUNICATION_EDGE_COLOR = '#FFD35F';
export const USER_IMPORTED_EDGE_COLOR = '#99FB7E';
